import {Box} from '@mui/material'
import {FC} from 'react'
import {Link} from 'react-router-dom'

interface TabsProps {
  activeTab: any
  setActiveTab: any
}

export const Tabs: FC<TabsProps> = ({activeTab, setActiveTab}) => {
  const renderTabs = (size: string) => {
    return (
      <ul
        className={`nav nav-stretch  flex-${
          size === 'xs' ? 'column' : 'center'
        } nav-pills border-transparent fs-4 flex-nowrap`}
      >
        <li className='nav-item'>
          <Link
            className={`nav-link me-6 ` + (activeTab === 0 && 'text-white active')}
            to='/dashboard'
            onClick={() => setActiveTab(0)}
          >
            خدمات متصل به پنجره ملی
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={`nav-link me-6 ` + (activeTab === 1 && 'text-white active')}
            to='/dashboard'
            onClick={() => setActiveTab(1)}
          >
            اساتید
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={`nav-link me-6 ` + (activeTab === 2 && 'text-white active')}
            to='/dashboard'
            onClick={() => setActiveTab(2)}
          >
            دانشجویان
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={`nav-link me-6 ` + (activeTab === 3 && 'text-white active')}
            to='/dashboard'
            onClick={() => setActiveTab(3)}
          >
            دانشجویان غیرایرانی
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={`nav-link me-6 ` + (activeTab === 4 && 'text-white active')}
            to='/dashboard'
            onClick={() => setActiveTab(4)}
          >
            والدین
          </Link>
        </li>
        <li className='nav-item'>
          <Link
            className={`nav-link me-6 ` + (activeTab === 5 && 'text-white active')}
            to='/dashboard'
            onClick={() => setActiveTab(5)}
          >
            کارکنان
          </Link>
        </li>
      </ul>
    )
  }
  return (
    <div className='card'>
      <div className='card-body pt-1 pb-0'>
        <Box component='div' sx={{display: {xs: 'block', md: 'none'}}}>
          {renderTabs('xs')}
        </Box>
        <Box component='div' sx={{display: {xs: 'none', md: 'block'}}}>
          {renderTabs('md')}
        </Box>
      </div>
    </div>
  )
}
